var _style, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMidwife(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.6 18.2",
    style: {
      enableBackground: "new 0 0 17.6 18.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#2C355E;stroke-width:0.25;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#2C355E;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.9,8.8c0,0-2.2-0.9-1.8-2.3c0,0,0.3-1,1.4-1.8c0,0,2.4-1,4.7,0.1c0,0,1.5,1,1.4,2.3c0,0-0.3,1.2-1.9,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.5,5c0,0-1.1,1.1-3,1c0,0,0,4.2,2.3,4.5c0,0,2.3,0.1,2.4-4.5C9.2,6.1,7.7,6.2,7.5,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.5,4.6L3.9,2.2c0,0,3.1-1.4,5.8,0L9.2,4.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "7.4,2.7 7.1,2.7 7.1,2.4 6.6,2.4 6.6,2.7 6.2,2.7 6.2,3.2 6.6,3.2 6.6,3.6 7.1,3.6 7.1,3.2 7.4,3.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.5,9.9c0,0,0.5,1.6-0.6,1.8l-1,0.3c0,0-1.7,0.4-1.8,4.8H8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.1,9.9c0,0-0.4,1.8,1,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.3,11.6c0,0,1.6,1,3.1,0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "5.2,11.6 6.8,16.2 8.5,11.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.8,16.7c0,0-0.9-1.2-0.2-2.7l2-4.1c0,0,1.4-2.1,3.7-0.9c0,0,2,1.1,1.3,3.5l-2,4.1L8.8,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.1,11.1c0,0,0.6,3.2,4.1,4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.4,13.8c0,0,2.1,1.1,3.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.8,10.4c0,0,0.9-0.9,2.2-0.3c0,0,1,0.7,0.7,1.8c0,0,0.5,0.2,0.2,0.7c0,0-0.2,0.3-0.6,0.2 c0,0-0.9,0.9-2.1,0.4c0,0-1.2-0.6-0.9-1.8c0,0-0.5-0.3-0.2-0.8C11.1,10.6,11.3,10.2,11.8,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.9,10.5c0.6,0,0.7-0.6,0.7-0.6s-0.1,0.7,0.2,1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.7,9.7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidwife);
export default __webpack_public_path__ + "static/media/midwife.4a575c7ebf81d8e7df7f5dd632acc76f.svg";
export { ForwardRef as ReactComponent };